import React from "react";
import { AiOutlineDelete, AiOutlineMinus, AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from "react-redux";
import { removeOrder, addCart } from "../../redux/menu/cartSlice";
import VegNonVegIcon from '../Common/VegNonVegIcons';

export default function OrderCard(props) {
    const dispatch = useDispatch();
    const { profile } = useSelector((state) => state.profile);
    
    // Calculate total price for this item
    const totalPrice = props.price * props.quantity;
    
    // Handle quantity change
    const handleQuantityChange = (newQuantity) => {
        if (newQuantity > 0) {
            // Update cart with new quantity
            dispatch(addCart({
                ...props,
                quantity: newQuantity
            }));
        } else if (newQuantity === 0) {
            // Remove item from cart
            dispatch(removeOrder(props.id));
        }
    };
    
    return (
        <div className="bg-white rounded-lg md:rounded-xl p-2.5 md:p-3 lg:p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300">
            <div className="flex items-start space-x-2 md:space-x-3 lg:space-x-4">
                {/* Product Image */}
                <div className="flex-shrink-0">
                    <img 
                        className="w-14 h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 object-cover rounded-md md:rounded-lg border border-gray-200" 
                        src={props.image} 
                        alt={props.name || props.title} 
                    />
                </div>
                
                {/* Product Details */}
                <div className="flex-1 min-w-0">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between">
                        <div className="flex-1 min-w-0">
                            <h5 className="text-sm md:text-base lg:text-lg font-semibold text-gray-800 poppins break-words leading-tight">
                                {props.name || props.title}
                            </h5>
                            
                            {/* Variant info if available */}
                            {props.variant && props.variant.name && props.variant.name.trim() !== '' && (
                                <p className="text-xs md:text-sm text-primary font-medium mt-0.5 md:mt-1 break-words">
                                    {props.variant.name}
                                </p>
                            )}
                            
                            {/* Veg/Non-veg indicator */}
                            {props.is_veg !== undefined && (
                                <div className="flex items-center mt-1 md:mt-2">
                                    <VegNonVegIcon 
                                        is_veg={props.is_veg} 
                                        className="w-3 h-3 md:w-4 md:h-4" 
                                        showLabel={true}
                                    />
                                </div>
                            )}
                        </div>
                        
                        {/* Price and Quantity */}
                        <div className="text-right mt-2 sm:mt-0 sm:ml-3 lg:ml-4 flex-shrink-0">
                            <div className="text-sm md:text-base lg:text-lg font-bold text-primary poppins">
                                {profile?.currency || 'AED'} {totalPrice.toFixed(2)}
                            </div>
                            <div className="text-xs md:text-sm text-gray-500 mt-0.5 md:mt-1">
                                {props.offerPrice && props.offerPrice !== null ? (
                                    <div className="flex flex-col items-end">
                                        <span className="text-green-600 font-semibold">
                                            {profile?.currency || 'AED'} {props.price.toFixed(2)} × {props.quantity}
                                        </span>
                                        <span className="text-gray-400 line-through text-xs">
                                            {profile?.currency || 'AED'} {props.originalPrice?.toFixed(2)} × {props.quantity}
                                        </span>
                                    </div>
                                ) : (
                                    <span>{profile?.currency || 'AED'} {props.price.toFixed(2)} × {props.quantity}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    
                    {/* Quantity Controls */}
                    <div className="flex items-center justify-between mt-2 md:mt-3">
                        <div className="flex items-center space-x-1.5 md:space-x-2 lg:space-x-3">
                            <button
                                onClick={() => handleQuantityChange(props.quantity - 1)}
                                className="w-6 h-6 md:w-7 md:h-7 lg:w-8 lg:h-8 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full flex items-center justify-center transition-colors duration-200 flex-shrink-0"
                                title="Decrease quantity"
                            >
                                <AiOutlineMinus className="w-2.5 h-2.5 md:w-3 md:h-3 lg:w-4 lg:h-4" />
                            </button>
                            
                            <span className="text-sm md:text-base lg:text-lg font-bold text-gray-800 min-w-[20px] md:min-w-[25px] lg:min-w-[30px] text-center">
                                {props.quantity}
                            </span>
                            
                            <button
                                onClick={() => handleQuantityChange(props.quantity + 1)}
                                className="w-6 h-6 md:w-7 md:h-7 lg:w-8 lg:h-8 bg-primary hover:bg-primary-dark text-white rounded-full flex items-center justify-center transition-colors duration-200 flex-shrink-0"
                                title="Increase quantity"
                            >
                                <AiOutlinePlus className="w-2.5 h-2.5 md:w-3 md:h-3 lg:w-4 lg:h-4" />
                            </button>
                        </div>
                        
                        {/* Remove Button */}
                        <button
                            onClick={() => dispatch(removeOrder(props.id))}
                            className="text-red-500 hover:text-red-700 transition-colors duration-200 p-1 md:p-1.5 lg:p-2 rounded-md md:rounded-lg hover:bg-red-50 flex-shrink-0"
                            title="Remove from cart"
                        >
                            <AiOutlineDelete className="w-3.5 h-3.5 md:w-4 md:h-4 lg:w-5 lg:h-5" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
